<script lang="ts">
import { defineComponent } from 'vue';
import { useFavoritesStore } from '@/stores/favorites';
import { mapActions, mapState, mapWritableState } from 'pinia';
import MultiDropDown from '@/components/popular/multi-drop-down.vue';
import PopularCompetitions from '@/components/popular/popular-competitions.vue';
import Competitions from '@/components/popular/competitions.vue';
import Pagination from '@/components/pagination.vue';
import Fixtures from '@/components/popular/fixtures.vue';
import Headline from '@/components/headline.vue';

export default defineComponent({
  name: 'popular-competitions-page',
  components: {
    Fixtures,
    Competitions,
    MultiDropDown,
    PopularCompetitions,
    Pagination,
    Headline: Headline,
  },
  computed: {
    ...mapState(useFavoritesStore, [
      'sports',
      'regions',
      'popularCompetitions',
      'popularCompetitionsCount',
      'competitions',
      'competitionsCount',
    ]),
    ...mapWritableState(useFavoritesStore, ['competitionsOffset', 'competitionsPageSize']),
  },
  data() {
    return {
      selectedSportIds: [] as number[],
      selectedRegionIds: [] as number[],
    };
  },
  methods: {
    ...mapActions(useFavoritesStore, [
      'fetchSports',
      'fetchRegions',
      'fetchPopularCompetitions',
      'fetchCompetitions',
    ]),
    fetchCompetitionsWithFilters() {
      this.fetchCompetitions({
        sportIds: this.selectedSportIds,
        regionIds: this.selectedRegionIds,
      });
    },
    flipCompetitionsPage(newOffset: number) {
      this.competitionsOffset = newOffset;
      this.fetchCompetitionsWithFilters();
    },
    resizeCompetitionsPage(newSize: number) {
      this.competitionsPageSize = newSize;
      this.fetchCompetitionsWithFilters();
    },
    addSportFilter(id: number) {
      if (this.selectedSportIds.find((sportId) => sportId === id)) {
        return;
      }
      this.selectedSportIds.push(id);
      this.fetchCompetitionsWithFilters();
    },
    addRegionFilter(id: number) {
      if (this.selectedRegionIds.find((regionId) => regionId === id)) {
        return;
      }
      this.selectedRegionIds.push(id);
      this.fetchCompetitionsWithFilters();
    },
  },
  mounted() {
    if (!this.sports) {
      this.fetchSports();
    }
    if (!this.regions) {
      this.fetchRegions();
    }
    if (!this.popularCompetitions) {
      this.fetchPopularCompetitions();
    }
    if (!this.competitions) {
      this.fetchCompetitions();
    }
  },
  watch: {
    selectedSportIds() {
      this.fetchCompetitionsWithFilters();
    },
    selectedRegionIds() {
      this.fetchCompetitionsWithFilters();
    },
  },
});
</script>

<template>
  <div class="grid gap-2">
    <teleport to="#title">
      <headline class="mx-4 my-2">
        Турниры в "Популярном"
        <template #counter>{{ popularCompetitionsCount }}</template>
      </headline>
    </teleport>

    <PopularCompetitions :competitions="popularCompetitions" />

    <headline class="mx-4 my-2">
      Доступные турниры
      <template #counter>{{ competitionsCount }}</template>
    </headline>

    <div
      class="grid grid-cols-[1fr_3fr_1fr_3fr_80px] gap-3 text-center"
      style="width: 100%; max-width: 100%"
    >
      <div class="place-content-center">Виды спорта</div>
      <MultiDropDown :options="sports" v-model="selectedSportIds" />
      <div class="place-content-center">Регионы</div>
      <MultiDropDown :options="regions" v-model="selectedRegionIds" />
      <button @click="fetchCompetitionsWithFilters">
        <i class="pi pi-refresh" style="font-size: 2rem" />
      </button>
    </div>
    <Competitions
      :addSportFilter="(id: number) => addSportFilter(id)"
      :addRegionFilter="(id: number) => addRegionFilter(id)"
      :competitions="competitions"
    />
    <div class="text-center">
      <Pagination
        :offset="competitionsOffset"
        :size="competitionsPageSize"
        :count="competitionsCount"
        :resizable="true"
        @flip="flipCompetitionsPage"
        @resize="resizeCompetitionsPage"
      />
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
